'use client';

import { c as _c } from "react/compiler-runtime";
import { AnimatePresence, motion } from 'motion/react';
import { useEffect, useRef, useState } from 'react';
interface AnimatedCounterProps {
  value: number;
  decimalPrecision?: number;
  fontSize?: string | number;
  color?: string;
  incrementColor?: string;
  decrementColor?: string;
}
export function AnimatedCounter(t0) {
  const $ = _c(22);
  const {
    value,
    decimalPrecision: t1,
    fontSize,
    color,
    incrementColor,
    decrementColor
  } = t0;
  const decimalPrecision = t1 === undefined ? 0 : t1;
  const [displayValue, setDisplayValue] = useState(value);
  const [direction, setDirection] = useState("up");
  const previousValueRef = useRef(value);
  let t2;
  let t3;
  if ($[0] !== value) {
    t2 = () => {
      if (value !== previousValueRef.current) {
        setDirection(value > previousValueRef.current ? "up" : "down");
        setDisplayValue(value);
        previousValueRef.current = value;
      }
    };
    t3 = [value];
    $[0] = value;
    $[1] = t2;
    $[2] = t3;
  } else {
    t2 = $[1];
    t3 = $[2];
  }
  useEffect(t2, t3);
  let t4;
  if ($[3] !== decimalPrecision || $[4] !== displayValue) {
    t4 = displayValue.toFixed(decimalPrecision);
    $[3] = decimalPrecision;
    $[4] = displayValue;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const formattedValue = t4;
  const displayColor = direction === "up" && incrementColor ? incrementColor : direction === "down" && decrementColor ? decrementColor : color;
  const t5 = fontSize ? typeof fontSize === "number" ? `${fontSize}px` : fontSize : undefined;
  let t6;
  if ($[6] !== displayColor || $[7] !== t5) {
    t6 = {
      fontSize: t5,
      color: displayColor
    };
    $[6] = displayColor;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  const style = t6;
  const t7 = direction === "up" ? 20 : -20;
  let t8;
  if ($[9] !== t7) {
    t8 = {
      y: t7,
      opacity: 0
    };
    $[9] = t7;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = {
      y: 0,
      opacity: 1
    };
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  const t10 = direction === "up" ? -20 : 20;
  let t11;
  if ($[12] !== t10) {
    t11 = {
      y: t10,
      opacity: 0
    };
    $[12] = t10;
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  let t12;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = {
      duration: 0.3,
      ease: "easeOut"
    };
    $[14] = t12;
  } else {
    t12 = $[14];
  }
  let t13;
  if ($[15] !== formattedValue || $[16] !== t11 || $[17] !== t8) {
    t13 = <AnimatePresence mode="wait" initial={false}><motion.span key={formattedValue} initial={t8} animate={t9} exit={t11} transition={t12} className="inline-block">{formattedValue}</motion.span></AnimatePresence>;
    $[15] = formattedValue;
    $[16] = t11;
    $[17] = t8;
    $[18] = t13;
  } else {
    t13 = $[18];
  }
  let t14;
  if ($[19] !== style || $[20] !== t13) {
    t14 = <div className="relative inline-block overflow-hidden" style={style}>{t13}</div>;
    $[19] = style;
    $[20] = t13;
    $[21] = t14;
  } else {
    t14 = $[21];
  }
  return t14;
}